<template>  
    <ion-toolbar color="background-transparent" class="sub-menu-toolbar" mode="md" id="sub-menu-toolbar">
        <div class="sub-nav-menu">
            <div class="sub-menu-chiplet" :class="button.visibilityClass" v-for="button in buttons" :key="button.name" @click="button.handler"> 
                <ion-icon class="chiplet-icon" :icon="button.icon" :src="button.src" mode="md" v-if="button.icon || button.src" />
            </div>
        </div>
    </ion-toolbar> 
</template>

<script lang="ts">
import {
    IonIcon
} from "@ionic/vue";
import {computed, defineComponent, onBeforeMount, ref} from "vue";
import { useRouter } from "vue-router";
import { shareSocial , help} from "ionicons/icons";
import translate from "../views/translate";
import {
    createLoadSpinner,
    readAndSaveJourneySets
} from "@/services/ShareService";
import { openJourneyHelpPagesModal } from "@/services/InformationPagesService";
import { useStore } from "vuex";
import { connectToInternetAlert} from "@/utilities/Alerts";
import {ActionSheetBuilder} from "@/utilities/ActionSheetBuilder";
import { AlertBuilder } from "@/utilities/AlertBuilder";
import {isValidJourneySetFilename, getJourneySetImportErrors} from "@/utilities/JourneySet";
import {checkAndRequestStoragePermission, deleteAndroidFiles, deleteApp} from "@/utilities/Filesystem";
import {getImageDataUri} from "@/utilities/Compatibility";
import { ChipletButton } from "@/types/types";

export default defineComponent({
    name: "SubMenuBar",
    props: ["pageName","buttons"],
    components: {
        IonIcon
    },
    setup() {
        const { t } = translate();
        const store = useStore();
        const platform = ref('');
        const router = useRouter();
        const isOfflineAndroid = computed(() => platform.value === "android" && t("messages.buildConfigs.config.appStoreBuild") !== "true")
        
        onBeforeMount(async () => {
            platform.value = await store.getters.platform();
        })

        
        return {
            t,
            localeMessages: computed(() => store.getters.getLocaleMessages()),
            shareAppText: computed(() => platform.value === "ios" || store.getters.getLocaleMessages().buildConfigs.config.appStoreBuild === 'true' ? t("messages.application.shareAppOnly"): t("messages.menu.shareApp")),
            isOfflineAndroid,
            showAllQuadrants: computed(() => store.getters.showAllQuadrants()),
            platform,
            shareSocial,
            help
        };
    },
});
</script>

<style scoped>

ion-toolbar.sub-menu-toolbar {
    background: transparent;
}

.sub-nav-menu {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    background: transparent;
    scroll-margin-block-start: 24px;
}
</style>
